import React from 'react';
import { Switch, Route } from 'react-router-dom';
import loadable from '@loadable/component';

import { baseUrl } from '../config/baseUrl';
const HomePage = loadable(() => import('../pages/HomePage'));
const PublicationsPage = loadable(() => import('../pages/PublicationsPage'));
const ApisPage = loadable(() => import('../pages/ApisPage'));
const NotFoundPage = loadable(() => import('../pages/NotFoundPage'));
const PublicDataPage = loadable(() => import('../pages/PublicDataPage'));
const MobileAppPage = loadable(() => import('../pages/MobileAppPage'));
const UserManualPage = loadable(() => import('../pages/UserManualPage'));
const PolicyAppPage = loadable(() => import('../pages/PolicyAppPage'));
const AdminPage = loadable(() => import('../pages/AdminPage'));
const CollectDataPage = loadable(() => import('../pages/CollectDataPage'));

const Routers = () => (
  <Switch>
    <Route path={`${baseUrl}public-data`} exact component={PublicDataPage} />
    <Route path={`${baseUrl}mobile-app/instruction`} exact component={UserManualPage} />
    <Route path={`${baseUrl}mobile-app/policy`} exact component={PolicyAppPage} />
    <Route path={`${baseUrl}mobile-app`} exact component={MobileAppPage} />
    <Route path={baseUrl} exact component={HomePage} />
    <Route path={`${baseUrl}publications`} exact component={(PublicationsPage)} />
    <Route path={`${baseUrl}publications/*`} exact component={(PublicationsPage)} />
    <Route path={`${baseUrl}collect-data`} exact component={(CollectDataPage)} />
    <Route path={`${baseUrl}collect-data/*`} exact component={(CollectDataPage)} />
  
    <Route path={`${baseUrl}apis`} exact component={(ApisPage)} />
    <Route path={`${baseUrl}apis/*`} exact component={(ApisPage)} />
    <Route path={`${baseUrl}admin`} exact component={(AdminPage)} />
    <Route path={`${baseUrl}admin/*`} exact component={(AdminPage)} />
    <Route path="*" component={NotFoundPage} />
  </Switch>
);

export default Routers;
